module.exports = __webpack_public_path__ + "img/03.4c24327c.png";